import React from "react";
import { ShadowInfoCard } from "@tennr/frontend/components/ShadowInfoCard";
import { HorizontalMarquee } from "@tennr/frontend/components/HorizontalMarquee";
import { Heading } from "@tennr/frontend/components/Heading";
import { Card } from "@tennr/frontend/components/Card";
import "./AboutPressSection.css";

export interface AboutPressSectionProps {
  className?: string;
}

export const AboutPressSection: React.FC<AboutPressSectionProps> = ({ className = "" }) => {
  const pressCards = [
    {
      logoSrc: "/figma/img/award-top-40.png",
      logoAlt: "Intelligent Applications 40",
      awardTitle: "Top 40 Private Companies\n2024",
    },
    {
      logoSrc: "/figma/svg/forbes-logo.svg",
      logoAlt: "Forbes",
      awardTitle: "Cloud 100 Rising Stars\n2024",
    },
    {
      logoSrc: "/figma/img/award-promising-startups.png",
      logoAlt: "The Information",
      awardTitle: "50 Most Promising Startups\n2024",
    },
    {
      logoSrc: "/img/cb-insights-logo.png",
      logoAlt: "CB Insights",
      awardTitle: "CB Insights Digital\nHealth 50 2024",
    },
    {
      logoSrc: "/figma/img/award-top-40.png",
      logoAlt: "Intelligent Applications 40",
      awardTitle: "Top 40 Private Companies\n2024",
    },
    {
      logoSrc: "/figma/svg/forbes-logo.svg",
      logoAlt: "Forbes",
      awardTitle: "Cloud 100 Rising Stars\n2024",
    },
    {
      logoSrc: "/figma/img/award-promising-startups.png",
      logoAlt: "The Information",
      awardTitle: "50 Most Promising Startups\n2024",
    },
    {
      logoSrc: "/img/cb-insights-logo.png",
      logoAlt: "CB Insights",
      awardTitle: "CB Insights Digital\nHealth 50 2024",
    },
    {
      logoSrc: "/figma/img/award-top-40.png",
      logoAlt: "Intelligent Applications 40",
      awardTitle: "Top 40 Private Companies\n2024",
    },
    {
      logoSrc: "/figma/svg/forbes-logo.svg",
      logoAlt: "Forbes",
      awardTitle: "Cloud 100 Rising Stars\n2024",
    },
    {
      logoSrc: "/figma/img/award-promising-startups.png",
      logoAlt: "The Information",
      awardTitle: "50 Most Promising Startups\n2024",
    },
    {
      logoSrc: "/img/cb-insights-logo.png",
      logoAlt: "CB Insights",
      awardTitle: "CB Insights Digital\nHealth 50 2024",
    },
  ];
  return (
    <section className={`about-press-section ${className}`}>
      <div className="about-press-section__container">
        <div className="about-press-section__content">
          <Heading
            title="PRESS"
            heading={"We processed over 10M patients in 2024.\nPeople are noticing."}
            body="Recent coverage of RaeLM™ and the future of healthcare ops."
            position="center"
            color="light"
            variant="hero"
            className="about-press-section__header"
          />

          <HorizontalMarquee autoscroll={true} autoscrollSpeed={0.1} widthMode="full" gap={26}>
            {pressCards.map((card, i) => (
              <ShadowInfoCard
                key={i}
                image={card.logoSrc}
                imageAlt={card.logoAlt}
                body={card.awardTitle}
                variant="light"
              />
            ))}
          </HorizontalMarquee>
        </div>
      </div>
    </section>
  );
};
